import React, {Component} from "react";
import PropTypes from "prop-types";
import * as _ from "lodash";
import separatorStyles from "./seperator.module.pcss";

const Seperator = ({color, width, height, gradientDirection}) => {

  const seperatorStyles = {
    width: width,
    height: height,
    ..._.isArray(color) ? {"backgroundImage": `linear-gradient(${gradientDirection}, ${color[0]},${color[1]})`} : null,
    ...!_.isArray(color) ? {"background": color} : null
  };

  return (
    <div className={separatorStyles.separator} style={seperatorStyles} />
  )
};

Seperator.defaultProps = {
  width: "100%",
  height: "3px",
  gradientDirection: "to right"
};

Seperator.propTypes = {
  color: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gradientDirection: PropTypes.string
};

export default Seperator;


// WEBPACK FOOTER //
// ./src/components/seperator/seperator.js